
import styled, { css } from "styled-components";

export const FieldOnRight = `&.MuiGrid-root {
    @media(min-width: 600px){padding-left: 8px}
}`;

export const FieldAlwaysOnRight = `&.MuiGrid-root {
    padding-left: 0.5rem;
    @media(max-width: 600px){
        padding-left: 8;
    }
}`;

export const FieldWithPopOver = "margin-right: 2px";

export const StyledFieldset = styled.fieldset`
    position: relative;
	width: 100%;
	border-radius: 8px;
	border: 1px solid var(--border-color);
	padding: 10px;
	display: flex;
`;

export const colorPickerStyle = css`
    margin-left:2px;  
    color: var(--input-font-color);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 30 30' width='24px' height='24px'%3E%3Cg id='surface216089114'%3E%3Cpath style='stroke:none;fill-rule:nonzero;fill:rgb(140, 137, 155);fill-opacity:1;' d='M 15 3 C 11.78125 3 8.863281 4.28125 6.707031 6.351562 C 6.558594 6.4375 6.433594 6.558594 6.347656 6.707031 C 4.28125 8.863281 3 11.785156 3 15 C 3 21.617188 8.382812 27 15 27 C 18.210938 27 21.125 25.726562 23.28125 23.664062 C 23.441406 23.574219 23.570312 23.441406 23.660156 23.28125 C 25.722656 21.125 27 18.210938 27 15 C 27 8.382812 21.617188 3 15 3 Z M 15 5 C 20.535156 5 25 9.464844 25 15 C 25 17.40625 24.15625 19.609375 22.746094 21.332031 L 8.667969 7.253906 C 10.390625 5.84375 12.59375 5 15 5 Z M 7.253906 8.667969 L 21.332031 22.746094 C 19.609375 24.15625 17.40625 25 15 25 C 9.464844 25 5 20.535156 5 15 C 5 12.59375 5.84375 10.390625 7.253906 8.667969 Z M 7.253906 8.667969 '/%3E%3C/g%3E%3C/svg%3E%0A");               
`;
